import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ortqfydrjvjlkttcczdl.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ydHFmeWRyanZqbGt0dGNjemRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzODYyMTksImV4cCI6MjA4ODk2MjIxOX0.0xm8TzT97FC26mGbROOoxBOfDVLVwUv2EzWmR5FLfQ8';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
